import { createSlice } from '@reduxjs/toolkit';
import { tableConfigInitialState } from './tableConfigInitialState';

export const tableConfigSlice = createSlice({
  name: 'tableConfig',
  initialState: tableConfigInitialState,
  reducers: {
    setAddExpanded(state, action) {
      const { isExpanded, tableKey } = action.payload;
      state.addExpanded[tableKey] = isExpanded;
    },
    setExpandedRow(state, action) {
      const { expanded, tableKey } = action.payload;
      state.expandedRow[tableKey] = expanded;
    },
    setFilter(state, action) {
      const { filter, tableKey } = action.payload;
      state.filters[tableKey] = filter;
    },
    setTablePagination(state, action) {
      const { pageSize, total, page, query, sortBy, sortDir, tableKey } =
        action.payload;
      state.pagination[tableKey] = {
        pageSize,
        total,
        page,
        query,
        sortBy,
        sortDir,
      };
    },
    cleanTableConfigSlice() {
      return tableConfigInitialState;
    },
  },
});

export const {
  cleanTableConfigSlice,
  setAddExpanded,
  setExpandedRow,
  setFilter,
  setTablePagination,
} = tableConfigSlice.actions;

export default tableConfigSlice.reducer;
